import React from 'react'
import Button from '@material-ui/core/Button'
import styled from 'styled-components'

const CloseButton = styled<any>(Button)`
    color: white;
    font-family: "Poppins";
`

export default ({ onClick }) => (
    <CloseButton onClick={onClick}>
        Close
    </CloseButton>
)